//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { DEFAULT_EMPTY_VALUE } from '@campaigns/constants/DefaultEmptyValuesConstants';
import { SubsectionText } from '@components/atoms/text/Text';
import StarEmptyImage from '@images/campaigns/sampling/star-empty.svg';
import StarImage from '@images/campaigns/sampling/star.svg';
import { isDefined } from '@utils/filterPredicates';

interface StarRatingProps {
  rating?: number;
  showNumericRating?: boolean;
}

export const StarRating = ({
  rating,
  showNumericRating = true,
}: StarRatingProps) => {
  if (!isDefined(rating)) {
    return <StyledSubsectionText>{DEFAULT_EMPTY_VALUE}</StyledSubsectionText>;
  }

  return (
    <StarRatingContainer>
      {Array.from({ length: 5 }).map((_, index) => (
        <StyledStarImage
          key={index}
          src={index < rating ? StarImage : StarEmptyImage}
          alt=''
        />
      ))}
      {showNumericRating && (
        <StyledSubsectionText>{rating.toFixed(1)}</StyledSubsectionText>
      )}
    </StarRatingContainer>
  );
};

const StarRatingContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacings[1]};
  `,
);

const StyledStarImage = styled.img`
  height: 20px;
  width: 20px;
`;

const StyledSubsectionText = styled(SubsectionText)`
  top: 0;
`;
